import React from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, Stack } from '@mui/material';
import { PortalConfig, PortalManagementFormValues } from '../types';
import { VendorProfile } from '@trnsact/trnsact-shared-types';
import { SwitchField } from 'components/form';

interface Props {
  isLoading: boolean;
  vendorProfile: VendorProfile;
  portalConfigurationConfig: PortalConfig;
  onConfirm: (configuration: PortalManagementFormValues) => Promise<void>;
}

export const PortalManagementForm = ({ isLoading, vendorProfile, portalConfigurationConfig, onConfirm }: Props) => {
  const { control, handleSubmit } = useForm<PortalManagementFormValues>({
    defaultValues: {
      allowSyndication: portalConfigurationConfig.allowSyndication,
      allowLMS: portalConfigurationConfig.allowLMS,
      multiLocationManagement: !!vendorProfile.multiLocationManagement,
    },
  });

  return (
    <Box sx={{ display: 'grid', gridTemplateRows: '1fr auto', gap: '1rem', height: '100%' }}>
      <Stack gap="0.5rem">
        <SwitchField label="Allow Syndication" control={control} name="allowSyndication" />
        <SwitchField label="Allow LMS" control={control} name="allowLMS" />
        <SwitchField label="Multi-location management" control={control} name="multiLocationManagement" />
      </Stack>
      <Box>
        <Button loading={isLoading} variant="contained" onClick={handleSubmit(onConfirm)} size="small">
          Save
        </Button>
      </Box>
    </Box>
  );
};
